import { render, staticRenderFns } from "./AgentPanel.vue?vue&type=template&id=c6f0f222&scoped=true"
import script from "./AgentPanel.vue?vue&type=script&lang=js"
export * from "./AgentPanel.vue?vue&type=script&lang=js"
import style0 from "./AgentPanel.vue?vue&type=style&index=0&id=c6f0f222&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f0f222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6f0f222')) {
      api.createRecord('c6f0f222', component.options)
    } else {
      api.reload('c6f0f222', component.options)
    }
    module.hot.accept("./AgentPanel.vue?vue&type=template&id=c6f0f222&scoped=true", function () {
      api.rerender('c6f0f222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/AgentPanel.vue"
export default component.exports